import { useEffect } from 'react';
import styled from 'styled-components';

import { useTracking } from '@xing-com/crate-communication-tracking';
import { useParams } from '@xing-com/crate-core-router';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { UpsellFrame } from '@xing-com/crate-upsell-frame';
import { GridContainer, GridItem } from '@xing-com/grid';
import { Section } from '@xing-com/layout-primitives';
import { containerPaddingS, mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { space4XL, space6XL } from '@xing-com/tokens';

import { ImagesWithMessage } from './components/images-with-message/images-with-message';
import { ProductBenefits } from './components/product-benefits/product-benefits';
import { ProductsHeader } from './components/products-header/products-header';
import { RegisterButton } from './components/register-button/register-button';

export const MainPage: React.FC = () => {
  const { product } = useParams();
  const { isLoggedOut } = useLoginState();
  const { track } = useTracking();

  useEffect(() => {
    track({
      event: 'viewed_screen',
      sentBy: 'purchase_funnel',
      page: 'purchase_funnel/products_welcome',
      context: product,
      application: 'wbm',
      type: 'nwt',
      eventSchema: 'basic',
    });
  }, [track]);

  const contents = (
    <Wrapper data-qa="mainWrapper">
      <StyledGridContainerWithGap variant="FullSize">
        <GridItem span={12}>
          <ProductsHeader />
        </GridItem>
        <StyledProjobsGridItem span={12}>
          <ProductBenefits product="projobs" />
        </StyledProjobsGridItem>
        <GridItem span={12}>
          <ProductBenefits product="premium" />
        </GridItem>
        <GridItem span={12}>
          <ImagesWithMessage />
        </GridItem>
      </StyledGridContainerWithGap>
    </Wrapper>
  );

  return isLoggedOut ? (
    <>
      <Section noBlockPadding>{contents}</Section>
      <RegisterButton />
    </>
  ) : (
    <UpsellFrame fullFooter>{contents}</UpsellFrame>
  );
};

const Wrapper = styled.div`
  @media ${mediaSmallOrTiny} {
    padding: 0 ${containerPaddingS};
  }
`;

const StyledGridContainerWithGap = styled(GridContainer)`
  gap: 0;

  & > :nth-child(n) {
    &:not(:last-child) {
      margin-bottom: ${space6XL};
    }
  }
`;

const StyledProjobsGridItem = styled(GridItem)`
  &&& {
    margin-bottom: ${space4XL};
  }
`;
